/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Link_TitleInputs */

const en_signin_link_title = /** @type {(inputs: Signin_Link_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email`)
};

/** @type {(inputs: Signin_Link_TitleInputs) => LocalizedString} */
const ar_signin_link_title = en_signin_link_title;

/** @type {(inputs: Signin_Link_TitleInputs) => LocalizedString} */
const he_signin_link_title = en_signin_link_title;

/** @type {(inputs: Signin_Link_TitleInputs) => LocalizedString} */
const ur_signin_link_title = en_signin_link_title;

/** @type {(inputs: Signin_Link_TitleInputs) => LocalizedString} */
const es_signin_link_title = en_signin_link_title;

/** @type {(inputs: Signin_Link_TitleInputs) => LocalizedString} */
const fr_signin_link_title = en_signin_link_title;

/** @type {(inputs: Signin_Link_TitleInputs) => LocalizedString} */
const de_signin_link_title = en_signin_link_title;

/** @type {(inputs: Signin_Link_TitleInputs) => LocalizedString} */
const pt_signin_link_title = en_signin_link_title;

/** @type {(inputs: Signin_Link_TitleInputs) => LocalizedString} */
const hi_signin_link_title = en_signin_link_title;

/** @type {(inputs: Signin_Link_TitleInputs) => LocalizedString} */
const bn_signin_link_title = en_signin_link_title;

/**
* | output |
* | --- |
* | "Check your email" |
*
* @param {Signin_Link_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_link_title = /** @type {((inputs?: Signin_Link_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Link_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_link_title(inputs)
	if (locale === "he") return he_signin_link_title(inputs)
	if (locale === "ur") return ur_signin_link_title(inputs)
	if (locale === "es") return es_signin_link_title(inputs)
	if (locale === "fr") return fr_signin_link_title(inputs)
	if (locale === "de") return de_signin_link_title(inputs)
	if (locale === "pt") return pt_signin_link_title(inputs)
	if (locale === "hi") return hi_signin_link_title(inputs)
	if (locale === "bn") return bn_signin_link_title(inputs)
	return /** @type {LocalizedString} */ ("Check your email")
});